module.exports = __webpack_public_path__ + "img/sld_aux.57186efc.svg";